export enum PusherChannel {
  ORGANISATION = "private-organisation-",
}

export const pusherOrganisationChannel = (organisationCode: string) =>
  PusherChannel.ORGANISATION + organisationCode;
